const initialState = {
        theme: true
};

export default initialState;